const {hashRoutes} = require('../../config/url');

export default {
    methods: {
        handleHashRoute(hashRoute, user) {
            switch (hashRoute) {
                case hashRoutes.registrationDialog:
                    this.$store.commit('OPEN_REGISTRATION_DIALOG');
                    break;
                case hashRoutes.loginDialog:
                    this.$store.commit('OPEN_LOGIN_DIALOG');
                    break;
                case hashRoutes.forgotPasswordDialog:
                    this.$store.commit('OPEN_FORGOT_PASSWORD_DIALOG');
                    break;
                case hashRoutes.checkConfirmSignupDialog:
                    this.$store.commit('OPEN_CHECK_CONFIRM_SIGNUP_DIALOG');
                    break;
                case hashRoutes.successConfirmSignupDialog:
                    this.$store.commit('OPEN_SUCCESS_CONFIRM_SIGNUP_DIALOG');
                    break;
                case hashRoutes.failedConfirmSignupDialog:
                    this.$store.commit('OPEN_FAILED_CONFIRM_SIGNUP_DIALOG');
                    break;
                case hashRoutes.wrongReferralLinkCode:
                    this.makeErrorToast(this.$t('front.agent.messages.wrong_referral_link_code'));
                    break;
                case hashRoutes.depositDialog:
                    if (user) {
                        this.$store.commit('OPEN_DEPOSIT_DIALOG');
                    } else {
                        this.$router.push({
                            hash: hashRoutes.loginDialog,
                        })
                            .then(() => this.$store.commit('SET_INTENDED_URL', {
                                hashRoute: hashRoutes.depositDialog,
                            }));
                    }
                    break;
                case hashRoutes.withdrawDialog:
                    if (user) {
                        this.$store.commit('OPEN_WITHDRAW_DIALOG');
                    } else {
                        this.$store.commit('OPEN_LOGIN_DIALOG');
                    }
                    break;
                case hashRoutes.fortuneWheel:
                    // fortune wheel fetches and handles permanent in AppContent.Vue
                    break;
                case hashRoutes.chat:
                    void require('../chat/index').maximizeChat(this);
                    break;
            }
        },
    },
}